import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useExternalServices } from 'hooks/use_external_services';

const OnRouteChange = () => {
  const { pathname } = useLocation();
  const { trackPage, updateIntercom } = useExternalServices();

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPage(pathname);
    updateIntercom();
  }, [pathname]);

  return null;
};

export default OnRouteChange;
